export enum PermissionEnum {
  admin = 'user:admin',
  operator = 'user:operator',
  analyst = 'user:analyst',
  viewer = 'user:viewer',
}
